module.exports = __webpack_public_path__ + "static/img/gjsc5.0031097.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common/gjsc5.jpg
// module id = et7Y
// module chunks = 0